import { injectable } from "inversify";
import "reflect-metadata";

@injectable()
export default class ToastService {
    counter = 0;

    private creator:
        | ((title: string, description: string, type: "success" | "error" | "warn" | "info", deadline: number) => void)
        | null = null;

    public bindStore(creator: (title: string, description: any, type: "success" | "error" | "warn" | "info", deadline: number) => void) {
        this.creator = creator;
    }

    public showToast(title: string, description: any, type: "success" | "error" | "warn" | "info" = "info", deadline: number = 7000) {
        this.counter++;

        const action = {
            type: "ADD_TOAST_MESSAGE",
            messageType: type,
            deadline,
            description,
            title,
            id: this.counter.toString(),
        };

        (window as any).store.dispatch(action);
        setTimeout(
            (v) => {
                (window as any).store.dispatch({
                    type: "HIDE_TOAST_MESSAGE",
                    v,
                });
            },
            deadline,
            this.counter.toString(),
        );
    }
}



// WEBPACK FOOTER //
// ./src/services/toast.service.ts